// extracted by mini-css-extract-plugin
export default {"sectionBox":"sectionBox---HAC9O"};